export const optimizeImage = (url) => {
  if (!url || typeof url !== 'string') {
    return ''
  }

  if (!url.includes('cloudinary.com')) {
    return url
  }

  const parts = url.split('/upload/')
  if (parts.length !== 2) {
    return url
  }

  return `${parts[0]}/upload/e_trim:10,w_320,w_320,c_fill,g_auto,f_auto/${parts[1]}`
}

export const optimizeLogo = (logoUrl) => {
  return optimizeImage(logoUrl)
}

export const getOptimizedBrandLogo = (brand) => {
  const logo = brand?.logo || ''
  return optimizeLogo(logo)
}

export const getLogoThumbnail = (logoUrl) => {
  if (!logoUrl || typeof logoUrl !== 'string') {
    return ''
  }

  if (!logoUrl.includes('cloudinary.com')) {
    return logoUrl
  }

  const parts = logoUrl.split('/upload/')
  if (parts.length !== 2) {
    return logoUrl
  }

  return `${parts[0]}/upload/w_64,h_64,c_fill,g_auto,f_auto/${parts[1]}`
}
